import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="relative py-32 bg-espresso overflow-hidden flex items-center justify-center" data-id="element-74">
      <div className="absolute inset-0 z-0" data-id="element-75">
        <img src="https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=1400&q=80" alt="Pan dulce glaseado con azúcar y canela" className="w-full h-full object-cover opacity-20" data-id="element-76" />
        <div className="absolute inset-0 bg-espresso/80" data-id="element-77"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-79">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-cream mb-8 leading-tight" data-id="element-80">
            Tu próxima hornada puede ser la que te devuelva el orgullo, el sabor
            y hasta una nueva fuente de ingreso.
          </h2>
          <p className="text-xl text-cream/80 mb-12 font-serif italic" data-id="element-81">
            El aroma a pan recién hecho te está esperando.
          </p>

          <a href="#comprar" className="inline-block bg-terracotta text-cream px-12 py-5 text-lg font-bold tracking-wide hover:bg-cream hover:text-espresso transition-colors duration-300 shadow-2xl hover:shadow-terracotta/20" data-id="element-82">
            Quiero mi ebook ahora
          </a>
        </motion.div>
      </div>
    </section>;
}